import { Breadcrumb, Button, PageHeader } from 'antd';
import { FC, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import ProductFilter from '../components/filters/product-filter';
import ProductsTable from '../components/tables/products-table';

const ProductsListRoute: FC = () => {
  const [filters, setFitlers] = useState()
  const navigate = useNavigate()

  return (<>
    <PageHeader
      title="محصولات"
      style={{ padding: " 16px 0" }}
      extra={[
        <Button key="add"><Link to="/products-form">افزودن</Link></Button>,
      ]}
      onBack={() => navigate(-1)}
    />
    <ProductFilter onFinish={setFitlers} />
    <ProductsTable filters={filters} />
  </>);
}

export default ProductsListRoute;
